module.exports = "<div kt-refresh-traveller-details-popup=modalCtrl.travelers kt-refresh-traveller-details-popup-close=$close kt-refresh-traveller-details-popup-dismiss=$dismiss></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/templates/refresh-traveller-details-modal.html
// module id = 3355
// module chunks = 0